var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 12.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 23.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.75,
    y: 12.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#172664",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.75,
    y: 23.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDashboard);
export default __webpack_public_path__ + "static/media/btn_dashboard.072fb650992249e1511a4a5715efdc51.svg";
export { ForwardRef as ReactComponent };